import {connect} from 'react-redux';
import {Component, cloneElement} from 'react';

import EventListener from 'topmeteo/general/components/EventListener';

class BasePositional extends Component {

    static getLeft({parentNode, clientWidth}, index) {
        return (parentNode.clientWidth / 24) * (index + 0.5) - (clientWidth / 2);
    }

    constructor(props) {
        super(props);

        this.onResize = this.onResize.bind(this);
    }

    render() {
        const {node, children, index, getEvents} = this.props;
        const left = node ? this.constructor.getLeft(node, index) : 0;
        const events = getEvents && getEvents(this.props);

        return (
            <EventListener {...events} target={window} onResize={this.onResize}>
                {cloneElement(children, {
                    style: {
                        left,
                    },
                })}
            </EventListener>
        );
    }

    componentDidUpdate({panelOpen}) {
        if (this.props.panelOpen && panelOpen === false) this.forceUpdate();
    }

    shouldComponentUpdate({isDragging}) {
        return isDragging === false || this.props.isDragging === false;
    }

    onResize() {
        this.forceUpdate();
    }

}

BasePositional.defaultProps = {
    getEvents: null,
};

const mapStateToProps = ({isDragging, panelOpen}, {id}) => ({
    isDragging: isDragging === id,
    panelOpen,
});

export default connect(mapStateToProps)(BasePositional);
